import { shallow } from "zustand/shallow";

import { type FilterConfig } from "../../config/types";
import useExplorerStore from "../../store/store";
import { FilterCheckboxList } from "../CheckboxList";
import CompositeFilterCheckboxList from "../CheckboxList/CompositeFilterCheckboxList";

const Filters = () => {
    const { filters, filterConfigs, applyFilter } = useExplorerStore(
        ({ config: { filters: filterConfigs }, filters, applyFilter }) => ({
            filters,
            filterConfigs,
            applyFilter,
        }),
        shallow,
    );

    const getSelectedValues = (config: FilterConfig) => {
        return filters[config.type]
            .filter((f) => f.prop === config.prop)
            .flatMap((f) => f.value);
    };

    return (
        <>
            {filterConfigs.map((fConfig) => {
                if (fConfig.prop === undefined) {
                    return (
                        <CompositeFilterCheckboxList
                            activeFilters={filters[fConfig.type]}
                            filter={fConfig}
                            key={fConfig.key}
                            isOpen={fConfig.open}
                            onChange={(f) => applyFilter(f)}
                        />
                    );
                }
                return (
                    <FilterCheckboxList
                        filter={fConfig}
                        key={fConfig.key}
                        isOpen={fConfig.open}
                        values={getSelectedValues(fConfig)}
                        onChange={(f) => applyFilter(f)}
                    />
                );
            })}
        </>
    );
};

export default Filters;
